import React from "react";
import { Card } from "react-bootstrap";
import SmuBadge from "../../utils/smu-badge/SmuBadge";
import "../../assets/styles/recent-summary.scss";
import SmuLoading from "../../utils/smu-loading/SmuLoading";

const RecentSummary = ({ children, title, badgeColor, noData, loading }) => {
  return (
    <Card body className="smu-card recent-summary">
      <Card.Header className="d-flex pt-2 pb-3 px-0">
        <div className="d-flex align-items-center me-auto">
          <SmuBadge _className="" color={badgeColor} />
          <div className="title mx-3">{title}</div>
        </div>
      </Card.Header>
      {
        (loading == true) ? 
          <div className="col-6 mb-4">  
            <SmuLoading/>
          </div>
        : <div className="content">
        {!!noData ? (
          <div className="text-center my-3 text-muted">No hay datos</div>
        ) : (
          children
        )}
      </div>
      }
      
    </Card>
  );
};

export default RecentSummary;
